import { Container } from 'src/components/common/Container'
import recommend_partner_join from 'src/assets/images/modal/recommend_partner_join.png'
import { useModal } from 'src/provider/ModalContextProvider'
import LazyImage from 'src/components/common/LazyImage'
import styled, { css } from 'styled-components'
import { Icon } from 'src/assets/svg/Icon'

const RecommendPartnerJoin = () => {
  const { closeModal } = useModal()

  const goToPartnerJoin = () => {
    closeModal()
    window.location.href = 'https://s.couponwallet.co.kr/5c9d52'
  }

  return (
    <S.ModalBackGroundWrap onClick={goToPartnerJoin}>
      <S.ModalWrap>
        <S.RecommendPartnerJoinContainer $option="flex_column" $row_gap="4px">
          <S.CloseButton   onClick={(e) => {e.stopPropagation(); closeModal()}}>
            <Icon.GrayX strokeWidth="1.6" />
          </S.CloseButton>
          <S.MainImageWrap >
            <LazyImage
              src={recommend_partner_join}
              alt="제휴사 가입 권장 이미지"
              style={S.MainImage}
            />
          </S.MainImageWrap>
        </S.RecommendPartnerJoinContainer>
      </S.ModalWrap>
    </S.ModalBackGroundWrap>
  )
}

export default RecommendPartnerJoin

const S = {
  ModalBackGroundWrap: styled.div`
    width: 100%;
    height: calc(var(--vh, 1vh) * 100);
    overflow: hidden;
    position: fixed;
    z-index: 9999;
    top: 0;
    left: 0;
    background-color: rgba(0, 0, 0, 0.7);
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    cursor: pointer;
  `,
  ModalWrap: styled.div`
    width: 100%;
    max-width: 360px;
    min-width: 280px;
    margin: 0 20px;
  `,
  RecommendPartnerJoinContainer: styled(Container)`
    align-items: flex-end;
  `,
  CloseButton: styled.button`
    padding: 0 7px;
    width: fit-content;
    z-index: 100;
  `,
  MainImageWrap: styled(Container)`
    position: relative;
    cursor: pointer;
  `,
  MainImage: css`
    width: 100%;
    min-height: 100px;
  `,
}
